import { useTranslation } from 'react-i18next';

function renderParagraphs(text: string, className?: string) {
  return text.split(/(?:\r?\n){2,}/).map((paragraph, index) => (
    <p key={index} className={className}>
      {paragraph}
    </p>
  ));
}

export default function CourseOverview() {
  const { t } = useTranslation();

  const rows: { labelKey: string; valueKey: string; accent?: boolean }[] = [
    { labelKey: 'coursesMaster.overview.rowDuration', valueKey: 'coursesMaster.overview.valueDuration' },
    { labelKey: 'coursesMaster.overview.rowHours', valueKey: 'coursesMaster.overview.valueHours' },
    { labelKey: 'coursesMaster.overview.rowPrice', valueKey: 'coursesMaster.overview.valuePrice', accent: true },
    { labelKey: 'coursesMaster.overview.rowSchedule', valueKey: 'coursesMaster.overview.valueSchedule' },
    { labelKey: 'coursesMaster.overview.rowFormat', valueKey: 'coursesMaster.overview.valueFormat' },
    { labelKey: 'coursesMaster.overview.rowCapacity', valueKey: 'coursesMaster.overview.valueCapacity' },
    { labelKey: 'coursesMaster.overview.rowTarget', valueKey: 'coursesMaster.overview.valueTarget' },
  ];

  return (
    <section className="relative py-16 md:py-20 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-12">
          {renderParagraphs(
            t('coursesMaster.overview.label'),
            'text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label',
          )}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('coursesMaster.overview.title')}
          </h2>
          <div className="gold-line mx-auto"></div>
        </div>
        <div className="table-scroll overflow-hidden border border-background-200/80">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[600px]">
              <thead>
                <tr className="bg-primary-900">
                  <th className="w-[180px] px-6 py-4 text-left text-[14px] text-accent-400 tracking-[0.1em] font-medium font-heading">
                    {t('coursesMaster.overview.colItem')}
                  </th>
                  <th className="px-6 py-4 text-left text-[14px] text-accent-400 tracking-[0.1em] font-medium font-heading">
                    {t('coursesMaster.overview.colContent')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={index} className={`border-t border-background-200/60 ${index % 2 === 0 ? 'bg-background-100/50' : 'bg-background-50'}`}>
                    <td className="px-6 py-4 text-[15px] text-foreground-500 tracking-[0.06em] font-label whitespace-nowrap">
                      {t(row.labelKey)}
                    </td>
                    <td className={`px-6 py-4 text-[16px] tracking-[0.04em] ${row.accent ? 'text-accent-700 font-medium' : 'text-foreground-800'}`}>
                      {renderParagraphs(
                        row.accent
                          ? t('coursesMaster.overview.priceFormat').replace('{price}', t('coursesMaster.overview.valuePrice'))
                          : t(row.valueKey),
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <p className="text-[13px] text-foreground-500 tracking-[0.04em] mt-5 text-center">
          {t('coursesMaster.overview.note')}
          <a href="/schedule" className="text-accent-600 hover:text-accent-500 underline underline-offset-2 transition-colors">
            {t('coursesMaster.overview.scheduleLink')}
          </a>
          {t('coursesMaster.overview.noteSuffix')}
        </p>
      </div>
    </section>
  );
}
